// extracted by mini-css-extract-plugin
export default {"rememberMe":"TgO8okoJ1wmM2gpnwBeM","switch":"SQqQcGwpKkJCqSraLQSQ","slider":"vyXDKDpdRFK5BdFxQIxG"};